'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSentimentVeryDissatisfied = function MdSentimentVeryDissatisfied(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 23.4c3.9 0 7.2 2.3 8.5 5.7h-17c1.3-3.4 4.6-5.7 8.5-5.7z m-7-3.4l-1.7-1.8 1.7-1.7-1.7-1.8 1.7-1.7 1.8 1.7 1.8-1.7 1.8 1.7-1.8 1.8 1.8 1.7-1.8 1.8-1.8-1.8z m14-7l1.8 1.7-1.8 1.8 1.8 1.7-1.8 1.8-1.8-1.8-1.8 1.8-1.8-1.8 1.8-1.7-1.8-1.8 1.8-1.7 1.8 1.7z m-7 20.4c7.3 0 13.4-6.1 13.4-13.4s-6.1-13.4-13.4-13.4-13.4 6.1-13.4 13.4 6.1 13.4 13.4 13.4z m0-30c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.4-16.6 16.6-16.6z' })
        )
    );
};

exports.default = MdSentimentVeryDissatisfied;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/sentiment-very-dissatisfied.js
// module id = 1161
// module chunks = 0